import { SHARED_QUERY_KEY } from '@moniebook-web/utils';

import { Axios } from '../api';
import { invalidateQuery } from '../cache';
import { REGISTERS_API_URL } from '../constants';
import {
    parsePropertiesToConfig,
    useBusinessConfigStore,
    useStaffSessionStore,
} from '../store';
import { type BusinessProperty } from '../types';

export class BusinessPropertyService {
    async fetchAndUpdate() {
        const { data } = await Axios.get<BusinessProperty[]>(
            REGISTERS_API_URL.REGISTER.BUSINESS_PROPERTY,
        );

        const store = useBusinessConfigStore.getState();
        const oldConfig = store.config;
        const newConfig = parsePropertiesToConfig(data);

        store.update(data);
        await invalidateQuery([SHARED_QUERY_KEY.GET_USER_PROPERTIES]);

        if (
            newConfig.sixDigitPinEnabled &&
            oldConfig.sixDigitPinEnabled !== newConfig.sixDigitPinEnabled
        ) {
            useStaffSessionStore.getState().logoutForPinUpgrade();
        }
    }
}
